<div class="audio-recorder-field">
	<div class="recorder-box" [class.recording]="isRecording">

		<div *ngIf="!isRecording && !isUploading && !value" class="state-container">
			<span class="instruction-text">Presiona para grabar</span>
			<button type="button" class="btn-action start" (click)="startRecording()">
				<nb-icon icon="mic-outline"></nb-icon>
			</button>
		</div>

		<div *ngIf="isUploading" class="state-container">
			<span class="instruction-text">Subiendo audio...</span>
		</div>

		<div *ngIf="isRecording" class="state-container">
			<div class="timer-container">
				<span class="recording-dot"></span>
				<span class="timer-text">{{ recordingTime || '00:00' }}</span>
			</div>
			<button type="button" class="btn-action stop" (click)="stopRecording()">
				<nb-icon icon="stop-circle-outline"></nb-icon>
			</button>
		</div>

		<div *ngIf="!isRecording && value" class="state-container">
			<div class="player-container">
				<audio [src]="audioUrl" controls controlsList="nodownload noplaybackrate" class="mini-player"></audio>
			</div>
			<div class="btn-remove-container">
				<button type="button" class="btn-remove" (click)="removeAudio()">
					<nb-icon icon="trash-2-outline"></nb-icon>
				</button>
			</div>
		</div>

	</div>

	<div class="footer-info mt-1">
		<small class="text-muted">Tiempo máximo de grabación: {{maxTimeMinutes}} minutos</small>
	</div>
</div>
